import { render } from "./CreateInventaire.vue?vue&type=template&id=8d5bc75e"
import script from "./CreateInventaire.vue?vue&type=script&lang=js"
export * from "./CreateInventaire.vue?vue&type=script&lang=js"

import "./CreateInventaire.vue?vue&type=style&index=0&id=8d5bc75e&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__